import { ServiceMaker, methods, services } from "@/services";

/** @param {{ page?: number, limit?: number }} params */
export const listTaxcode = (params = {}) => {
  const page = params.page != null ? Number(params.page) : 1;
  const limit = params.limit != null ? Number(params.limit) : 500;
  return ServiceMaker(
    `/cpq/tax-codes/view?page=${page}&limit=${limit}`,
    methods.GET,
    services.master
  );
};

export const createTaxcode = payload =>
  ServiceMaker(
    `/cpq/tax-codes/create`,
    methods.PUT,
    services.master,
    payload
  );

export const updateTaxcode = payload =>
  ServiceMaker(
    `/cpq/tax-codes/edit`,
    methods.PATCH,
    services.master,
    payload
  );

export const deleteTaxcode = Id =>
  ServiceMaker(`/cpq/tax-codes/remove`, methods.DELETE, services.master, {
    _id: Id
  });
